import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = ({ setAuthenticated }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    
    if (token) {
      // Store the token in localStorage
      localStorage.setItem('jwt_token', token);

      // Set authentication state to true
      setAuthenticated(true);

      // Redirect to homepage or a protected route
      navigate('/');
    } else {
      // Handle error or redirect to login if token is not present
      setAuthenticated(false);
      navigate('/login');
    }
  }, [navigate, setAuthenticated]);

  return <div>Logging you in...</div>;
};

export default AuthCallback;
